<template>
  <div>
    <div :id="id" class="g2-attach-container glz_card">
      <table class="attach-header col-md-12">
        <thead>
          <tr>
                    <th v-for="(val, key, index) in attachHeaderData" :key="index" :width='val'>{{key}}</th>
          </tr>
        </thead>
      </table>
      <div class="form-group g2-attach-wrapper col-md-12" ref="attachContainer">
        <div v-for="(attachConfig, index) of configArray" :id="id + '_' + attachConfig.configId"
          :name="id + '_' + attachConfig.configId" :class="'g2-attach-div ' + cssClass"
          :attachType="attachConfig.attachType" formFieldName="attachId" :style="cssStyle" :data-bv-attach="true"
          :key="index" ref="aAttach">
          <div :id="id + '_' + attachConfig.configId + '_plupload_wrapper'">
            <div class="plupload_container">
              <div class="plupload_content_container">
                <table class="table table-hover attach-table col-md-12">
                  <tr>
                    <td v-if="attachHeaderData['编号']" :width="attachHeaderData['编号']">
                      {{ index + 1 }}
                    </td>
                    <td v-if="attachHeaderData['附件类型']" :width="attachHeaderData['附件类型']"
                      style="vertical-align: middle;overflow: hidden;" :title="attachConfig.attachType">
                      <span class="required" v-if="attachConfig.required == 'true'" style="color: red">
                        *
                      </span>
                      <!-- <el-tooltip ref="tlp" effect="dark" placement="top" :content="attachConfig.attachType"
                        :disabled="attachConfig.attachType.length < 27">
                        <div class="attchtypes">
                          {{
                              attachConfig.attachType
                          }}
                        </div>
                      </el-tooltip> -->
                      {{ attachConfig.attachType }}
                      <span v-if="attachConfig.remark">
                        {{ attachConfig.remark }}
                      </span>
                    </td>
                    <td v-if="attachHeaderData['附件信息']" :width="attachHeaderData['附件信息']" style="
                        vertical-align: middle;
                        overflow: hidden;
                        white-space: normal;
                        word-break: break-all;
                      ">
                      <table class="plupload_filelist_content">
                        <tr>
                          <div class="plupload_content" height="50px"></div>
                        </tr>
                      </table>
                      <div class="plupload_clearer">&nbsp;</div>
                    </td>
                    <td v-show="!readonlyOrDisabled" :width="attachHeaderData['上传']">
                      <div class="plupload_filelist plupload_filelist_footer">
                        <div class="plupload_file_name">
                          <div class="plupload_buttons">
                            <template v-if="attachConfig.fileFilters">
                              <el-tooltip class="item" effect="dark" :content="computeTitle(attachConfig)"
                                placement="left">
                                <el-button class="btn btn-primary plupload_add">添加</el-button>
                              </el-tooltip>&nbsp;
                            </template>
                            <template v-else>
                              <el-button class="btn btn-primary plupload_add">添加</el-button>&nbsp;
                            </template>
                            <a v-if="!autostart" class="
                                plupload_hidden
                                btn btn-default btn-sm
                                plupload_start
                              " title="开始上传">开始</a>&nbsp;
                            <a v-if="!autostart" class="
                                plupload_hidden
                                btn btn-default btn-sm
                                plupload_stop
                              " title="停止上传">停止</a>&nbsp;
                            <el-button v-if="
                              JSON.parse(attachConfig.needSignSeal) &&
                              attachConfig.signBtn
                            " class="btn btn-primary plupload_qz" @click="signView(attachConfig.configId)">签章
                            </el-button>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <input class="plupload_count" value="0" type="hidden" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
export default {
    name:'attach',
  props: {
    attachArray: {
      type: Object,
      default: () => { },
    },
    // <![CDATA[附件的配置对象及其对应的附件列表的映射关系（Map）， key 的类型为 gboat2.attachment.model.AttachConfig， value 的类型为 java.util.List&lt;gboat2.attachment.model.Attachment&gt;]]
    attachMap: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    // Set the html disabled attribute on rendered html element]]
    disabled: {
      type: Boolean,
      default: false,
    },
    // 是否允许通过拖拽选择要上传的文件 默认值为：true]]
    dragdrop: {
      type: Boolean,
      default: false,
    },
    // 处理文件上传逻辑 Action 的 URL 默认值为：upload.do]]
    url: {
      type: String,
      default: "/attach/upload",
    },
    // 删除附件的 URL。默认值为 upload/deleteFile]]
    deleteUrl: {
      type: String,
      default: "/attach/deleteFile",
    },
    // 下载附件的 URL 默认值为：upload/download]]
    downloadUrl: {
      type: String,
      default: "/attach/download",
    },
    // <![CDATA[自定义列的显示比例，例如：{'编号' : '7%', '附件名称' : '79%', '上传' : '14%'}]]
    columns: {
      type: Object,
    },
    /* attachConfig: {
            type: Object,
            default: ()=>{
                return {}
            }
        }, */
    // 附件所归属的数据记录的主键（ID）值]]
    belongId: String,
    // HTML id attribute]]
    id: {
      type: String,
      default: "",
    },

    buttons: {
      type: Object,
      default: () => {
        return {
          start: true,
          stop: true,
        };
      },
    },
    attachArrayStr: String,
    resize: String,
    rename: String,
    sortable: {
      type: Boolean,
      default: false,
    },
    views: String,
    extraColumn: String,
    // 自定义扩展列,需要配置一个函数]]
    extraColumns: Function,
    // <![CDATA[页面是否显示缩略图]]
    thumb: String,
    // <![CDATA[缩略图类型：nginx、origin、file。nginx会在图片路径中加入/thumb_ng,file会在图片名后面加上_thumb_ng,origin为原始文件]]
    thumbType: String,
    // <![CDATA[选择完要上传的文件后，是否自动上传 默认值为：false]]
    autostart: {
      type: Boolean,
      default: true,
    },
    // 块的大小，设置了该属性时，文件会分块上传， 支持的单位有 b, kb, mb, gb, tb， 如： 204800 或 '204800b' 或 '200kb' 默认值为：0]]
    chunkSize: {
      type: String,
      default: "0",
    },
    // The css class to use for element]]
    cssClass: {
      type: String,
      default: "",
    },
    // The css style definitions for element to use]]
    cssStyle: String,
    // 如果为true，则在点删除按钮时不触发删除动作，只有在提交表单的时候才会删除。默认值为 false]]
    virtualDel: {
      type: Boolean,
      default: false,
    },
    // 虚删除模式下删除的附件ID列表名称，使用该字段后会在删除附件后自动添加以当前值为name的隐藏域。默认值为 virtualDelIds]]
    virtualDelIds: {
      type: String,
      default: "virtualDelIds",
    },
    // 文件表单域字段的名称 默认值为：file]]
    fileDataName: {
      type: String,
      default: "file",
    },
    // Flash swf 文件的 URL]]
    flashSwfUrl: String,
    // 自定义上传文件的请求头，是一个键值对的 JSON 格式字符串，如： {'name': 'hemw', 'password': 'testPWD'}]]
    headers: {
      type: Object,
    },
    // 允许上传的最大值，， 支持的单位有 b, kb, mb, gb, tb， 如： 10mb、1gb]]
    maxFileSize: String,
    // 在触发错误事件（Error event）之前重试上传文件或分块的次数 默认值为：0]]
    maxRetries: {
      type: Number,
      default: 0,
    },
    // 是否允许一次选择多个文件 默认值为：true]]
    multiSelection: {
      type: Boolean,
      default: true,
    },
    // 是否以 Multipart formated 的方式发送文件和附加参数 默认值为：true]]
    multipart: {
      type: Boolean,
      default: true,
    },
    // 上传每个文件时，一并发送的附件参数， 该属性值是一个 JSON 格式字符串，如： {'author': 'hemw'}]]
    multipartParams: {
      type: Object,
    },
    // 在每次上传之后重新激活小部件 默认值为：true]]
    multipleQueues: {
      type: Boolean,
      default: true,
    },
    // The name to set for element]]
    name: String,
    // 上传完所有文件时触发的事件]]
    onComplete: {
      type: Function,
    },
    // 当发生错误时触发的事件]]
    onError: {
      type: Function,
    },
    // 处理文件上传时触发的事件]]
    onProgress: {
      type: Function,
    },
    // 上传控件完成初始化后触发的事件]]
    onReady: {
      type: Function,
    },
    // 移除队列中的文件时触发的事件]]
    onRemoved: {
      type: Function,
    },
    // 移除队列中的文件时触发的事件]]
    onUpdatelist: {
      type: Function,
    },
    // 选择文件后关闭弹出对话框时触发的事件]]
    onSelected: {
      type: Function,
    },
    // 开始文件上传时触发的事件]]
    onStart: {
      type: Function,
    },
    // 中断文件上传时触发的事件]]
    onStop: {
      type: Function,
    },
    // 每上传完一个文件时触发的事件]]
    onUploaded: {
      type: Function,
    },
    // 是否防止重复， 默认不允许重复，如果值为 true， 则同一次上传的队列中不能包含两个路径相同的文件 默认值为：false]]
    preventDuplicates: {
      type: Boolean,
      default: true,
    },
    // 运行时（浏览器）应该具备的特性，可以是 key1=value1,key2=value2 或 {key1:value1,key2:value2} 的形式]]
    requiredFeatures: [String, Object],
    // If set to true, the rendered element will indicate that input is required 默认值为：false]]
    requiredLabel: {
      type: Boolean,
      default: false,
    },
    // Define required position of required form element (left|right)]]
    requiredPosition: String,
    // 逗号分隔的一系列运行环境的值，将逐一尝试，直到找到可以正确执行的运行环境 默认值为：html5,flash,silverlight,html4]]
    runtimes: String,
    // Silverlight xap 文件的 URL]]
    silverlightXapUrl: String,
    // The template (other than default) to use for rendering the element]]
    template: String,
    // The template directory.]]
    templateDir: String,
    // The theme (other than default) to use for rendering the element]]
    theme: String,
    // 如果值为 true， 则会为上传的文件生成唯一的文件名 默认值为：false]]
    uniqueNames: String,
  },
  data() {
    return {
      fileList: this.attachMap.uploadeds,
            configArray: this.attachMap.types
        }
  },
  methods: {
    initOptions() {
      var options = Object.assign(
        {},
        {
                runtimes: 'html5,flash',
          // eslint-disable-next-line no-undef
          deleteUrl: basePath + this.deleteUrl,
          // eslint-disable-next-line no-undef
          downloadUrl: basePath + this.downloadUrl,
          virtualDel: this.virtualDel,
          belongId: this.belongId,
          dragdrop: !!this.dragdrop,
          ready: this.onReady,
          selected: this.onSelected,
          removed: this.onRemoved,
          updatelist: this.onUpdatelist,
          start: this.onStart,
          stop: this.onStop,
          progress: this.onProgress,
          uploaded: this.onUploaded,
          complete: this.onComplete,
          error: this.onError,
          extraColumns: this.extraColumns,
          readonly: this.readonly || this.disabled,
          max_file_size: this.maxFileSize,

          flash_swf_url: this.flashSwfUrl,
          silverlight_xap_url: this.silverlightXapUrl,
          virtualDelIds: () => {
            if (this.virtualDel && this.virtualDelIds) {
              // eslint-disable-next-line no-undef
                        return virtualDelIds
            }
          },
          attachArray: this.optionsAttachArrray,
          // 判断属性
          /* autoOpen: ${attachConfig.autoOpen}, */
          chunk_size: this.chunkSize,
          file_data_name: this.fileDataName,
          headers: this.headers,
          max_retries: this.maxRetries,
          multipart: !!this.multipart,
          multipart_params: this.multipartParams,
          multi_selection: !!this.multiSelection,
          prevent_duplicates: !!this.preventDuplicates,
          required_features: !!this.requiredFeatures,
          resize: this.resize,
          // eslint-disable-next-line no-dupe-keys
          runtimes: this.runtimes,
          unique_names: !!this.multiSelection,
          autostart: !!this.autostart,
          rename: !!this.rename,
          sortable: !!this.sortable,
          buttons: this.buttons,
          views: this.views,
          multiple_queues: !!this.multipleQueues,
          columns: this.columns,
          thumb: this.thumb,
          thumbType: this.thumbType,
                extraColumn: this.extraColumn
            })
      var array = options.attachArray;
      var attachDivs = this.$refs.attachContainer.children;
      for (let i = 0; i < attachDivs.length; i++) {
        // eslint-disable-next-line no-undef
        var option = $.extend({}, options, array[i]);
        // eslint-disable-next-line no-undef
        delete options.attachArray;
        //  _this.$q.fn.plupload = window.plupload.Uploader
        // 判断下载链接是否经session校验
        if (option.attachConfig.nosessionDownload === "true") {
          // eslint-disable-next-line no-undef
          option.downloadUrl = basePath + "/attach/nosession/download";
        }
        // eslint-disable-next-line no-undef
        $(attachDivs[i]).plupload(option);
      }
    },
    checkAttachId() {
      if (this.fileList && this.fileList.length > 0) {
        this.fileList.forEach((elementf) => {
          elementf.signBtn = false;
          this.configArray.forEach((elementC, index) => {
            if (elementf.configId === elementC.configId)
              this.$set(this.configArray[index], "signBtn", true);
          });
        });
      }
    },
    signView(configId) {
      const attachIdArr = this.fileList.filter((elm) => {
        return elm.configId === configId;
      });
      const attachcodeArr = this.configArray.filter((elm) => {
        return elm.configId === configId;
      });
      this.$emit("goSign", {
        attachId: attachIdArr[0].attachId,
        attachcode: attachcodeArr[0].attachCode,
        originalName: attachIdArr[0].originalName,
      });
    },
    computeTitle(attachConfig) {
      if (attachConfig.fileFilters) {
        return "允许添加" + attachConfig.fileFilters + "格式文件";
      }
      return null;
    },
    validate() {
      /* eslint-disable */
      // return true;
      var attachDivs = this.$refs.attachContainer.children;
      for (let i = 0; i < attachDivs.length; i++) {
        var $field = $(attachDivs[i]);
        var pluploadOpts = $field.plupload("option"),
          files = $field.plupload("getFiles") || [];
        if (pluploadOpts.readonly) {
          // 如果为只读，直接返回 true
          $field.removeAttr("tabIndex");
          return true;
        }
        var uploadedCount = 0;
        for (var j = 0; j < files.length; j++) {
          var status = files[j].status;

          if (status == plupload.QUEUED) {
            // 没有上传
            // options.error = {
            //     code: "queued",
            //     name: files[i].name
            // };
            $field.attr("tabIndex", -1);
            $field.plupload("notify", "error", "请先上传未上传的附件");
            return false;
          }

          if (status == plupload.UPLOADING) {
            // 正在上传
            // options.error = {
            //     code: "uploading",
            //     name: files[i].name
            // };
            $field.attr("tabIndex", -1);
            $field.plupload(
              "notify",
              "error",
              "有正在上传的附件，请等待上传完成后再进行操作"
            );
            return false;
          }

          if (status == plupload.FAILED) {
            // 上传失败
            $field.attr("tabIndex", -1);
            $field.plupload("notify", "error", "附件上传失败");
            return false;
          }

          if (status == plupload.DONE) {
            // 上传成功
            uploadedCount++;
          }
        }

        if (
          pluploadOpts.attachConfig.required == "true" &&
          uploadedCount <= 0
        ) {
          $field.attr("tabIndex", -1); // 将 tabIndex 设置为 -1，使得 DIV 可以获取焦点
          $field.plupload("notify", "error", "请至少上传一个附件");
          return false;
        }

        $field.removeAttr("tabIndex");
      }
      return true;
    },
  },
  computed: {
    optionsAttachArrray() {
      var attachArray = [];
      if (this.configArray) {
        for (var j = 0; j < this.configArray.length; j++) {
          var attachObject = {};
          attachObject.attachConfig = this.configArray[j];
          var uploadeds = [];
          for (var i = 0; i < this.fileList.length; i++) {
            if (this.configArray[j].configId === this.fileList[i].configId) {
              uploadeds.push(this.fileList[i]);
            }
          }
          attachObject.uploadeds = uploadeds;
          attachArray.push(attachObject);
        }
      }
      return attachArray;
    },
    attachHeaderData() {
      if (this.columns) {
        // 用户自定义列名
        return this.columns;
      } else {
        if (this.readonlyOrDisabled) {
          // 只读情况下没有上传按钮
          //之前         4%
          return { 编号: "4%", 附件类型: "34%", 附件信息: "62%" };
        } else {
          return { 编号: "4%", 附件类型: "22%", 附件信息: "60%", 上传: "14%" };
        }
      }
    },
    readonlyOrDisabled() {
      return this.readonly || this.disabled;
    },
  },
  mounted() {
    this.initOptions(); // 初始化附件参数
    this.checkAttachId();
  },
};
</script>

<style scoped lang="scss">
.col-md-1,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12 {
  float: none;
}

th,
td {
  text-align: center;
  border-bottom: 1px solid #edeff3;
  color: #909399;
  font-weight: 500;
  padding: 5px;
  height: 40px;
  color: #555;
}

.attach-header th {
  height: 40px;
  border-bottom: 0;
  font-size: 14px;
  background-color: #e5e5e5;
  font-weight: bold;
}

.plupload_filelist_content {
  width: 100%;
}

.plupload_filelist_content td {
  border: 0;
}

.g2-attach-wrapper {
  padding-right: 0;
  padding-left: 0;
}

.plupload_filelist_content {
  text-align: center !important;
}

.mydeletefile {
  font-size: 15px;
  color: #d00b0b;
  cursor: pointer;
}

.btn-primary {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
}

.btn-primary:hover {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
}

.btn-primary:focus {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
}

.plupload_buttons {
  margin-left: 16px;
}

.btn {
  padding: 5px 9px;
  font-size: 13px;
  margin: 7px 0 7px;
}

.upload-img-show-modal {
  overflow-y: hidden;
}

/deep/.plupload_content {
  .ui-icon {
    text-indent: 0px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/attach.vue